var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.631 1.026c-.657-1.368-2.607-1.368-3.264 0L8.126 6.94s-.004.005-.009.006l-6.54.856C.072 8-.542 9.858.57 10.908l4.78 4.507c.003.002.002.004.002.004l-1.2 6.44c-.28 1.503 1.31 2.638 2.64 1.92L12 20.4a.014.014 0 0 1 .014 0l5.196 3.38c1.33.718 2.921-.417 2.64-1.92l-1.2-6.44.002-.004 4.78-4.507c1.114-1.05.5-2.908-1.007-3.105l-6.54-.856c-.005-.001-.008-.006-.008-.006l-2.245-5.915Z"
  })));
};
export default SvgStarFilled;